module.exports = __webpack_public_path__ + "img/About.f6370c7f.jpg";